import { render, staticRenderFns } from "./AdminCardsHistory.vue?vue&type=template&id=fb8a4056"
import script from "./AdminCardsHistory.vue?vue&type=script&lang=js"
export * from "./AdminCardsHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminCardsHistory.vue?vue&type=style&index=0&id=fb8a4056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports